<template>
	<el-dialog class="invoiceImgDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
			</div>
		</div>
		<div class="dislogConent">
			<div class="threeImg" v-if="objFileUrl">
				<ObjViewer :url="objFileUrl" />
			</div>
		</div>
		<div slot="footer">
			<!-- <div class="menuBox">
				<div class="submit" @click="downloadImages(objFileUrl)">
					<img class="downloadIcon" src="../assets/Register/download.png" />
					下载保存
				</div>
			</div> -->
		</div>
	</el-dialog>
</template>

<script>
	import ObjViewer from '../components/ObjViewer.vue'
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			objFileUrl: {
				type: String,
				default: '',
			},
		},
		components: {
			ObjViewer,
		},
		data() {
			return {}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			getFileNameFromUrl(url) {
				// 从 URL 中提取文件名
				return url.substring(url.lastIndexOf('/') + 1);
			},
			async downloadImages(url) {
				try {
					// 使用 fetch 获取原图 Blob
					const response = await fetch(url, {
						mode: 'cors'
					});
					const blob = await response.blob();

					// 创建临时 a 标签下载
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = this.getFileNameFromUrl(url); // 使用原始文件名
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					// 释放对象 URL
					URL.revokeObjectURL(link.href);
				} catch (err) {
					console.error('下载失败', url, err);
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.invoiceImgDialog {

		::v-deep .el-dialog {
			width: 10.8rem;
			border-radius: .12rem;
			background: none;

			.dislogTitle {
				height: .46rem;
			}

			&__headerbtn {
				top: .12rem;
				right: 0;
				font-size: .24rem;
			}

			&__header {
				padding: 0 0;
			}

			&__body {
				padding: 0 0;

				.threeImg {
					width: 10.8rem;
					height: 5.6rem;
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem .16rem 0;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 2.8rem;
						height: .52rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .26rem;
						font-weight: 500;
						font-size: .15rem;
						color: #FFFFFF;
						line-height: .52rem;
						cursor: pointer;

						.downloadIcon {
							width: .12rem;
							height: .12rem;
							margin-right: .04rem;
						}
					}
				}
			}
		}
	}
</style>